import React from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'
import {time_ago_txt} from 'Skelet/src/modules/time_ago.js'
import refresh_icon from './28406.svg';


class TTVChannels extends React.Component {

  constructor(props) {
    super(props);

    this.state = {};
  }

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "ttv_channel_list", "GET", config.api_url+"/ttv-channel-list?t="+this.props.session_token);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "ttv_channel_list", "GET", config.api_url+"/ttv-channel-list?t="+nextProps.session_token);
    }
  }

  render() {
    let card = null, cards = null, end_of_list_text = "", refresher_text = "", page_cards = this.props.apiData["ttv_channel_list"];
    if(page_cards !== undefined) {

      cards = page_cards.data.map(function(item, i) {
        item.time_ago_txt = time_ago_txt(item.created_on);
        item.time_ago_txt2 = time_ago_txt(item.updated_on);
        //item.fpvr = (parseInt(item.followers, 10) / parseInt(item.views, 10) * 100).toFixed(1);

        return <div key={"1k"+i} className="contact">
          <div>[{item.ext_id}] <a href={"https://twitch.tv/"+item.name+"/about"} target="_blank">{item.name}</a></div>
          {/*<div style={{color:"#9347FF"}}>{parseInt(item.followers, 10).toLocaleString()} followers &middot; <span style={{opacity:".6"}}>{parseInt(item.views, 10).toLocaleString()} views</span> &middot; {item.fpvr}%</div>*/}
          <div style={{color:"#9347FF"}}>{parseInt(item.followers, 10).toLocaleString()} followers</div>
          <small style={{opacity:".5", display:"block", fontSize:"75%"}}>{item.time_ago_txt} &middot; {item.time_ago_txt2}</small>
          <small style={{opacity:".5", display:"block", fontSize:"75%"}}>{item.created_on} &middot; {item.updated_on}</small>
        </div>;
      });
      card = <div className="card contacts">{cards}</div>;
    }

    if(page_cards === undefined || page_cards.isFetching) {
      end_of_list_text = "Laden..";
      refresher_text = "Laden.. ";
    } else if((page_cards !== undefined && !page_cards.isFetching)) {
      if(page_cards.data[0] !== undefined) {
        end_of_list_text = "Einde van resultaten.";
        refresher_text = "";
      } else {
        end_of_list_text = "Geen TTVChannels.";
        refresher_text = "";
      }
    }

    return (
      <div className="container content" ref={this.setWrapperRef}>
        <div className="card-layout">
          <div className="card-layout-div50"><strong>TTVChannels</strong></div>
          <div className="card-layout-div50 refresher">{refresher_text}<img src={refresh_icon} alt="Vernieuwen" onClick={() => this.refresh()}/></div>
        </div>
        {page_cards !== undefined && page_cards.data[0] !== undefined && card}
        <div className="end_of_list_text">{end_of_list_text}</div>
      </div>
    );
  }

  refresh() {
    this.props.clearStateBlock("ttv_channel_list");
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TTVChannels)



// WEBPACK FOOTER //
// ./src/containers/TTVChannels.js